module.exports = __webpack_public_path__ + "img/arch.eafc94dd.svg";